import React from 'react'
import { matchPath } from 'react-router-dom'
import { SearchFilterProvider } from '../../../views/providers'
import { PortfoliosPage, PortfolioWizard, ConfirmPortfolioActivation } from '.'
import { PropertyApiProvider } from '../../api/property'
import PortfoliosProvider from '../PortfoliosProvider'
import { PortfolioStatement } from '../../accounting/components'
import { ROUTES } from '../../../constants/routes'
import { ContactsProvider } from '../../contacts'
import PropertiesProvider from '../../properties/PropertiesProvider'
import EditProperty from '../../properties/components/EditProperty/EditProperty'

const PortfoliosRoute = (props: any) => {
  const focusMatchPath = matchPath(props.location.pathname, {
    path: ROUTES.portfolioEdit,
    exact: false,
    strict: false,
  })

  const editPropertyMatchPath = matchPath(props.location.pathname, {
    path: ROUTES.editProperty,
    exact: true,
    strict: false,
  })

  return (
    <PropertyApiProvider>
      <PortfoliosProvider {...props}>
        <ContactsProvider {...props}>
          <SearchFilterProvider location={props.location}>
            <PortfoliosPage />
            <PortfolioStatement />
          </SearchFilterProvider>
          {focusMatchPath && (
            <>
              <PortfolioWizard match={focusMatchPath} />
              <ConfirmPortfolioActivation />
            </>
          )}
          {editPropertyMatchPath && (
            <PropertiesProvider {...props}>
              <EditProperty />
            </PropertiesProvider>
          )}
        </ContactsProvider>
      </PortfoliosProvider>
    </PropertyApiProvider>
  )
}

export default PortfoliosRoute
